import * as React from "react";
import Box from "@mui/material/Box";
import { createSvgIcon } from "@mui/material/utils";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function PingcapLogoIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 769.89 203.08" {...props}>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="#082265"
            d="M100.11,47.34l-88-25.1A9.5,9.5,0,0,0,0,31.38v162.2a9.51,9.51,0,0,0,9.48,9.5,9.35,9.35,0,0,0,2.22-.26l88-21h0a9.48,9.48,0,0,0,7.3-9.25V56.48A9.54,9.54,0,0,0,100.11,47.34Z"
          />
          <path
            fill="#00aeef"
            d="M160.05,41.57a9.55,9.55,0,0,0-6.88-9.11L41.16.37A9.5,9.5,0,0,0,29,9.51V132.59a9.47,9.47,0,0,0,11.72,9.23l112.14-27a9.47,9.47,0,0,0,7.28-9.26Z"
          />
          <path
            fill="#303eab"
            d="M100.11,47.34,29,27.07V132.59a9.47,9.47,0,0,0,11.72,9.23L107,125.88V56.48A9.54,9.54,0,0,0,100.11,47.34Z"
          />
          <path
            fill="#082265"
            d="M576.1,126.26h0l-.23.37a40.12,40.12,0,0,1-13.72,13.09,36.62,36.62,0,0,1-18.78,5.43c-10.94,0-20.51-4.36-28.42-13a43.82,43.82,0,0,1-11.37-31,43.09,43.09,0,0,1,11.74-29.38c7.62-8.17,16.81-12.31,27.3-12.31,14.37-.13,25.2,5.8,33.13,18.13L576,78h.22l9.33-5.77a51.65,51.65,0,0,0-15.42-16.39,48.17,48.17,0,0,0-26.73-8.09A46.85,46.85,0,0,0,507.66,63c-9.94,10.23-15,23.28-15,38.77,0,15,5,28.08,14.84,38.9,9.81,10.64,21.69,16,35.33,16h.51c17.92-.37,32.69-9.06,42.11-24.6Z"
          />
          <polygon
            fill="#082265"
            points="645.84 49.09 633.16 49.09 586.01 154.63 601.05 154.63 615.63 119.55 615.65 119.55 620.8 108.59 620.78 108.59 639.76 64.05 658.36 108.59 631.66 108.59 626.79 119.55 662.69 119.55 677.4 154.63 690.66 154.63 645.84 49.09"
          />
          <path
            fill="#082265"
            d="M759.63,58.75c-7-6.32-15.81-9.52-26.18-9.52H699.3v105.4h12.44V113.34h0V102.25h0V60.59H734a24.73,24.73,0,0,1,16.22,5.63,18.12,18.12,0,0,1,7.37,14c.39,6.62-1.77,11.88-6.61,16.07a23.43,23.43,0,0,1-16.31,6H721.77v11.09h14.91a33.34,33.34,0,0,0,23.23-8.85,29,29,0,0,0,10-21.91C770,72.89,766.58,64.87,759.63,58.75Z"
          />
          <rect
            fill="#082265"
            x="296.25"
            y="51.17"
            width="12.44"
            height="12.44"
          />
          <rect
            fill="#082265"
            x="296.25"
            y="79.04"
            width="12.44"
            height="75.74"
          />
          <path
            fill="#082265"
            d="M483.63,147.21V114.69a38.6,38.6,0,0,0-12.25-29.2c-8.22-8.22-18.1-12.27-29.35-12a39.17,39.17,0,0,0-27.82,12.54,40.08,40.08,0,0,0-11.29,28.49,41,41,0,0,0,12.24,29.59c8.19,8.18,18,12.12,29.22,11.71a38.78,38.78,0,0,0,27.48-12.33v5.17m0,0c0,6.88-2.73,12.89-8.11,17.88a27.1,27.1,0,0,1-19,7.73,27.83,27.83,0,0,1-16.93-5.64,25.92,25.92,0,0,1-9-10.54l-9.52,5.5a36.63,36.63,0,0,0,9.94,12c6.6,5.25,14.75,8.13,24.23,8.54.59,0,1.18,0,1.77,0a40.89,40.89,0,0,0,26-9.25c8.17-6.52,12.32-14.86,12.32-24.8v-2.95m-12-31.74a29.23,29.23,0,0,1-8.41,20.22,25.68,25.68,0,0,1-19.5,8.38,27.3,27.3,0,0,1-20.2-8.39,28.22,28.22,0,0,1-8.66-20.34,28.66,28.66,0,0,1,7.88-20.61,27.21,27.21,0,0,1,19.53-9.45c.51,0,1,0,1.5,0,7.61,0,14,2.85,19.45,8.69A28.51,28.51,0,0,1,471.59,115.47Z"
          />
          <path
            fill="#082265"
            d="M274.1,58.75c-7-6.32-15.81-9.52-26.19-9.52H213.76v105.4h12.45V113.34h0V102.25h0V60.59h22.24a24.73,24.73,0,0,1,16.23,5.63,18.12,18.12,0,0,1,7.37,14c.39,6.62-1.77,11.88-6.61,16.07a23.43,23.43,0,0,1-16.31,6H236.24v11.09h14.91a33.34,33.34,0,0,0,23.23-8.85,29,29,0,0,0,10-21.91C284.5,72.89,281.05,64.87,274.1,58.75Z"
          />
          <path
            fill="#082265"
            d="M357.54,74.41c-9.92,0-18.3,3.43-24.94,10.2s-9.91,15.24-9.91,25.33v44.53h12V108.86a21.82,21.82,0,0,1,6.75-16.1A22.08,22.08,0,0,1,357.54,86a21.49,21.49,0,0,1,15.82,6.75,21.86,21.86,0,0,1,6.89,16.1v45.61h12V109.94c0-10.09-3.34-18.61-9.92-25.33A33.47,33.47,0,0,0,357.54,74.41Z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function PingcapLogoWithoutTextIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 30" {...props}>
      <path
        d="M15.0084 6.99048L1.81174 3.27494C1.38677 3.16303 0.917055 3.23017 0.55918 3.49877C0.201305 3.76736 0 4.17025 0 4.61791V28.5899C0 29.0151 0.201305 29.418 0.536813 29.6866C0.782852 29.8881 1.09599 30 1.40913 30C1.52097 30 1.63281 29.9776 1.74464 29.9552L14.9189 26.844C15.5676 26.6873 16.0149 26.1278 16.0149 25.4787V8.33345C16.0373 7.70673 15.6123 7.14716 15.0084 6.99048Z"
        fill="#172D72"
      />
      <path
        d="M23.9778 6.13991C23.9778 5.51319 23.5529 4.95362 22.949 4.79695L6.17356 0.0517958C5.74858 -0.0601181 5.27887 0.00703027 4.921 0.275624C4.56312 0.544217 4.36182 0.947107 4.36182 1.39476V19.592C4.36182 20.0172 4.56312 20.4201 4.89863 20.6887C5.14467 20.8902 5.45781 20.9797 5.77095 20.9797C5.88279 20.9797 5.99462 20.9573 6.10646 20.9349L22.9042 16.9508C23.5529 16.7941 24.0002 16.2345 24.0002 15.5854L23.9778 6.13991Z"
        fill="#00AEEF"
      />
      <path
        d="M15.0086 6.9905L4.36182 3.99121V19.592C4.36182 20.0173 4.56312 20.4202 4.89863 20.6888C5.14467 20.8902 5.45781 20.9797 5.77095 20.9797C5.88279 20.9797 5.99462 20.9574 6.10646 20.935L16.0375 18.5848V8.33347C16.0375 7.70675 15.6125 7.14718 15.0086 6.9905Z"
        fill="#3D3FEA"
      />
    </SvgIcon>
  );
}

export function PingcapLogoFooterIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 98 26" fill="none" {...props}>
      <path
        d="M39.8024 6.68462H38.2456V8.23794H39.8024V6.68462Z"
        fill="white"
      />
      <path
        d="M39.8024 10.1767H38.2456V19.6531H39.8024V10.1767Z"
        fill="white"
      />
      <path
        d="M45.8612 9.58899C45.2783 9.57411 44.6988 9.67987 44.1589 9.89959C43.6191 10.1193 43.1308 10.4482 42.7247 10.8656C42.3149 11.2856 41.9939 11.7834 41.7807 12.3295C41.5675 12.8756 41.4664 13.4589 41.4835 14.0448V19.6417H42.9886V13.9169C42.9819 13.5402 43.0543 13.1663 43.2012 12.8192C43.3482 12.4722 43.5663 12.1597 43.8416 11.9018C44.1029 11.6309 44.4167 11.4157 44.7638 11.2694C45.111 11.1231 45.4843 11.0487 45.8612 11.0507C46.2338 11.0465 46.6033 11.1191 46.9465 11.2639C47.2897 11.4087 47.5993 11.6226 47.8559 11.8923C48.1311 12.1509 48.35 12.4633 48.4991 12.8099C48.6481 13.1566 48.7241 13.5302 48.7222 13.9074V19.6417H50.2274V14.0448C50.2442 13.4571 50.1409 12.8722 49.9239 12.3257C49.7069 11.7791 49.3807 11.2823 48.9651 10.8656C48.565 10.4493 48.0824 10.1208 47.5479 9.90096C47.0135 9.68116 46.439 9.57491 45.8612 9.58899Z"
        fill="white"
      />
      <path
        d="M61.7596 18.7143V14.6459C61.7756 13.9638 61.6477 13.2859 61.3841 12.6564C61.1205 12.0268 60.7272 11.4596 60.2296 10.9916C59.7774 10.5253 59.2376 10.1525 58.6411 9.89442C58.0445 9.63633 57.4028 9.49802 56.7526 9.48739C56.1024 9.47676 55.4565 9.59401 54.8518 9.83245C54.247 10.0709 53.6953 10.4259 53.228 10.8771C53.1687 10.9343 53.1114 10.9935 53.054 11.0526C52.1288 12.0089 51.6213 13.2921 51.6426 14.6211C51.6367 15.3083 51.7691 15.9897 52.0319 16.6249C52.2947 17.2601 52.6826 17.8363 53.1726 18.3193C53.6426 18.8105 54.2127 19.1955 54.8445 19.4484C55.4763 19.7012 56.155 19.8159 56.835 19.7848C57.4825 19.769 58.1204 19.6247 58.7114 19.3603C59.3025 19.0959 59.8348 18.7167 60.2774 18.2448V18.8917M60.2774 18.8784C60.2792 19.3029 60.1895 19.7229 60.0143 20.1098C59.839 20.4967 59.5825 20.8414 59.2619 21.1206C58.947 21.4286 58.5743 21.6715 58.165 21.8353C57.7557 21.999 57.318 22.0804 56.877 22.0747C56.1126 22.0789 55.368 21.8321 54.758 21.3725C54.2743 21.0384 53.885 20.5856 53.6277 20.0577L52.4363 20.7466C52.735 21.3328 53.1594 21.8461 53.6794 22.2503C54.5478 22.9254 55.6137 23.2986 56.7145 23.3132H56.9402C58.1311 23.32 59.2863 22.9079 60.2029 22.1491C60.6874 21.7899 61.0799 21.3213 61.3481 20.7816C61.6163 20.242 61.7528 19.6467 61.7462 19.0444V18.7009M60.2488 14.7337C60.2385 15.6811 59.86 16.5876 59.1931 17.2621C58.8825 17.6017 58.5031 17.8716 58.0801 18.0539C57.6571 18.2362 57.2001 18.3266 56.7393 18.3193C56.267 18.3286 55.7979 18.24 55.3617 18.059C54.9255 17.878 54.5317 17.6086 54.2053 17.2678C53.5237 16.5954 53.1319 15.6842 53.1134 14.728C53.0948 13.7719 53.4509 12.8462 54.1059 12.148C54.4082 11.7918 54.7822 11.5029 55.2036 11.3001C55.625 11.0973 56.0843 10.985 56.5519 10.9706H56.7432C57.2041 10.9639 57.6609 11.0579 58.0815 11.2462C58.5021 11.4344 58.8763 11.7123 59.1778 12.0602C59.5361 12.4039 59.8168 12.8201 60.0008 13.2808C60.1849 13.7416 60.2681 14.2363 60.2449 14.7317L60.2488 14.7337Z"
        fill="white"
      />
      <path
        d="M73.3512 16.0866L73.3149 16.1362C72.8848 16.8154 72.2936 17.3784 71.5936 17.7754C70.8841 18.2096 70.0697 18.4431 69.2374 18.4509C67.87 18.4509 66.6651 17.9014 65.6726 16.8251C64.7087 15.7657 64.1956 14.3738 64.242 12.9437C64.2483 11.5757 64.773 10.2606 65.7108 9.26268C66.1382 8.77658 66.6651 8.38758 67.256 8.12193C67.8469 7.85627 68.488 7.72014 69.1361 7.72272C70.9434 7.70936 72.2974 8.44785 73.29 9.98782L73.3149 10.0393H73.3397L74.5063 9.31229C74.0185 8.49472 73.3596 7.79176 72.5747 7.25138C71.5806 6.59524 70.416 6.24307 69.224 6.23809C68.3844 6.21999 67.5505 6.38084 66.7781 6.70991C66.0057 7.03898 65.3126 7.52869 64.745 8.14635C63.5 9.42679 62.8631 11.0679 62.8631 13.0067C62.8348 14.8078 63.4994 16.5513 64.7201 17.8785C65.9499 19.2142 67.4416 19.8802 69.1495 19.8802H69.2107C71.4578 19.8306 73.3149 18.7353 74.4929 16.8003L73.3512 16.0866Z"
        fill="white"
      />
      <path
        d="M82.1104 6.43273H80.5211L74.5924 19.6417H76.4877L78.3179 15.2527L78.9586 13.8883L81.3435 8.29901L83.6786 13.8826H80.3298L79.7159 15.247H84.2198L86.0635 19.636H87.7331L82.1104 6.43273Z"
        fill="white"
      />
      <path
        d="M96.3947 7.63303C95.4904 6.83506 94.3158 6.41006 93.1091 6.44418H88.8098V19.6398H90.3646V14.4703V13.0811V7.87347H93.1435C93.8829 7.85905 94.6034 8.10726 95.1765 8.5738C95.4521 8.77883 95.6784 9.04265 95.8389 9.34604C95.9993 9.64943 96.0899 9.98473 96.104 10.3275C96.1399 10.7052 96.0833 11.0859 95.9391 11.437C95.7948 11.788 95.5672 12.0988 95.2759 12.3426C94.7187 12.8445 93.9895 13.1136 93.2391 13.0945H91.6135V14.4837H93.4839C94.5638 14.4995 95.6076 14.0958 96.3947 13.3578C96.7877 13.0165 97.103 12.5952 97.3194 12.1222C97.5358 11.6492 97.6483 11.1355 97.6493 10.6156C97.6813 10.056 97.5849 9.49648 97.3675 8.97963C97.1501 8.46277 96.8174 8.00222 96.3947 7.63303Z"
        fill="white"
      />
      <path
        d="M35.4611 7.63303C34.5559 6.8351 33.3808 6.41014 32.1735 6.44418H27.8819V19.6398H29.4386V14.4703V13.0811V7.87347H32.2232C32.9628 7.85788 33.6838 8.10622 34.2562 8.5738C34.5326 8.77806 34.7595 9.04172 34.9201 9.34527C35.0806 9.64882 35.1707 9.9845 35.1837 10.3275C35.2205 10.7053 35.1643 11.0863 35.02 11.4374C34.8756 11.7886 34.6476 12.0993 34.3556 12.3426C33.7975 12.848 33.0646 13.1176 32.3112 13.0945H30.6932V14.4837H32.5617C33.6423 14.4998 34.6868 14.096 35.4744 13.3578C35.8649 13.017 36.1782 12.5973 36.3939 12.1265C36.6095 11.6558 36.7224 11.1447 36.7252 10.6271C36.76 10.0646 36.664 9.50163 36.4447 8.98225C36.2254 8.46287 35.8888 8.00111 35.4611 7.63303Z"
        fill="white"
      />
      <path
        d="M45.9376 9.60044C45.3565 9.58541 44.7786 9.69114 44.2406 9.91092C43.7026 10.1307 43.2164 10.4597 42.8126 10.8771C42.403 11.2947 42.0819 11.7905 41.8687 12.3348C41.6554 12.879 41.5543 13.4606 41.5714 14.0448V19.6169H43.0766V13.9074C43.0699 13.5307 43.1423 13.1568 43.2892 12.8097C43.4361 12.4626 43.6542 12.1501 43.9295 11.8923C44.1906 11.621 44.5043 11.4056 44.8515 11.2593C45.1987 11.113 45.5722 11.0387 45.9491 11.0412C46.3208 11.0379 46.6891 11.1119 47.0305 11.2584C47.372 11.405 47.6791 11.6208 47.9324 11.8923C48.2076 12.1508 48.4264 12.4632 48.5752 12.8099C48.7239 13.1566 48.7994 13.5302 48.7968 13.9074V19.6169H50.3038V14.0448C50.3207 13.4605 50.2193 12.8788 50.0057 12.3345C49.7922 11.7903 49.4707 11.2946 49.0607 10.8771C48.6549 10.463 48.1685 10.1361 47.6315 9.9166C47.0944 9.69706 46.518 9.58946 45.9376 9.60044Z"
        fill="white"
      />
      <path
        d="M20.3582 4.0798L6.31671 0.0610093C6.1291 0.00562615 5.9324 -0.0123436 5.73783 0.00812623C5.54326 0.028596 5.35463 0.0871044 5.18272 0.180311C5.01082 0.273517 4.85899 0.399596 4.73592 0.551349C4.61284 0.703102 4.52093 0.877557 4.46543 1.06475C4.42506 1.19845 4.40445 1.3373 4.40423 1.47694V3.28978L2.65622 2.79172C2.43668 2.72681 2.20475 2.71529 1.97983 2.75811C1.75491 2.80094 1.54354 2.89687 1.36338 3.03789C1.17948 3.17495 1.03015 3.3529 0.927234 3.55762C0.824319 3.76233 0.770656 3.98817 0.770508 4.21719L0.770508 24.5249C0.772032 24.7498 0.824418 24.9714 0.923761 25.1733C1.0231 25.3752 1.16684 25.5521 1.34425 25.6908C1.60756 25.8896 1.92825 25.998 2.25842 25.9999C2.37094 25.9985 2.4828 25.9824 2.59119 25.9522L13.63 23.3227C13.9565 23.2518 14.2487 23.0711 14.4576 22.8109C14.6665 22.5507 14.7795 22.2268 14.7775 21.8934V16.264L20.3008 14.9282C20.6296 14.8562 20.9233 14.6731 21.1324 14.4099C21.3414 14.1467 21.453 13.8195 21.4483 13.4837V5.49572C21.4483 5.17286 21.3414 4.85904 21.1443 4.603C20.9472 4.34696 20.6708 4.16304 20.3582 4.0798ZM6.13503 16.8651C6.08029 16.8782 6.02258 16.8693 5.97438 16.8403C5.95046 16.8258 5.92969 16.8067 5.91327 16.7841C5.89685 16.7615 5.88511 16.7358 5.87875 16.7086C5.87684 16.6909 5.87684 16.673 5.87875 16.6552L5.85963 5.20567L13.0831 7.25132C13.154 7.2719 13.2163 7.31479 13.2607 7.37359C13.3052 7.4324 13.3294 7.50397 13.3298 7.57763V15.1343L6.13503 16.8651ZM5.86154 18.3574H5.88831C6.00362 18.3599 6.11875 18.3471 6.23065 18.3192L13.3298 16.6018V21.3724L13.3183 21.6548C13.3178 21.7314 13.2926 21.8058 13.2464 21.8669C13.2003 21.9281 13.1356 21.9728 13.062 21.9945L2.49174 24.4962C2.46455 24.5029 2.43629 24.5039 2.40867 24.4993C2.38105 24.4948 2.35466 24.4846 2.33109 24.4695C2.30718 24.455 2.28641 24.4359 2.26999 24.4133C2.25357 24.3907 2.24183 24.365 2.23547 24.3379C2.23356 24.3207 2.23356 24.3034 2.23547 24.2863V4.45C2.2344 4.39762 2.25373 4.34687 2.2894 4.30843C2.32507 4.26999 2.3743 4.24686 2.42672 4.24391C2.45024 4.24466 2.47348 4.24917 2.49557 4.25727L4.40805 4.79539V16.8842C4.40629 17.0767 4.44253 17.2676 4.51472 17.4461C4.5869 17.6245 4.69362 17.7871 4.82877 17.9244C4.96391 18.0618 5.12485 18.1712 5.30238 18.2464C5.47991 18.3217 5.67057 18.3614 5.86345 18.3631L5.86154 18.3574ZM13.7027 5.92699L5.86154 3.69433L5.84815 1.71738C5.84814 1.66034 5.87059 1.60557 5.91065 1.56489C5.95072 1.5242 6.00519 1.50084 6.06235 1.49984H6.12546L19.7232 5.37932C19.7972 5.40126 19.8617 5.44709 19.9067 5.50961C19.9517 5.57213 19.9746 5.64779 19.9718 5.72472L19.9833 13.2738C19.9879 13.3477 19.9655 13.4208 19.9201 13.4795C19.8747 13.5381 19.8095 13.5782 19.7366 13.5925L14.7699 14.787V7.35818C14.7696 7.03703 14.6652 6.72459 14.4721 6.46763C14.2791 6.21067 14.0078 6.023 13.6989 5.93272L13.7027 5.92699Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export function StackOverflowIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M18.372 20.222v-5.358h1.79V22H4v-7.136h1.79v5.358h12.582Z"
      />
      <path
        fill="currentColor"
        d="m7.768 14.356l8.79 1.824l.372-1.755L8.14 12.6l-.372 1.756Zm1.162-4.157l8.14 3.764l.744-1.617l-8.14-3.787l-.744 1.64Zm2.256-3.973l6.907 5.705l1.14-1.363l-6.907-5.704l-1.14 1.362ZM15.651 2L14.21 3.062l5.35 7.16L21 9.159L15.651 2Zm-8.07 16.42h8.977v-1.778H7.581v1.778Z"
      />
    </SvgIcon>
  );
}

export function SlackIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M6 15a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2h2v2m1 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2a2 2 0 0 1-2-2v-5m2-8a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2v2H9m0 1a2 2 0 0 1 2 2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2a2 2 0 0 1 2-2h5m8 2a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-2v-2m-1 0a2 2 0 0 1-2 2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2a2 2 0 0 1 2 2v5m-2 8a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2v-2h2m0-1a2 2 0 0 1-2-2a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2a2 2 0 0 1-2 2h-5Z"
      />
    </SvgIcon>
  );
}

export function AskTugIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 40 40" {...props}>
      <g
        xmlns="http://www.w3.org/2000/svg"
        data-name="组 4428"
        fill="currentColor"
      >
        <g data-name="组 4427">
          <path
            d="m11.261 20.637-.172-.172.007.008-.007-.007-.074.068v.044l-.022-.024-.109.109-.043.681.174-.175v.008l.4-.4-.145-.146Z"
            data-name="路径 13710"
            transform="translate(-1539 -1382) translate(149 -167) translate(-14 2.909) translate(1415.989 1553.091)"
          />
          <path
            d="M20.011 8.611a8.61 8.61 0 0 0-14.78-6.006L2.695 5.147c-.112.1-.22.211-.321.315L-.001 7.849l.306.33a8.189 8.189 0 0 1 1.772-1.155l.035-.017 1.2-1.2a7.709 7.709 0 0 1 11.02 10.757L13 17.901l-.016.034a8.182 8.182 0 0 1-1.294 1.931l.327.309 2.4-2.4c.2-.183.395-.385.576-.59l2.041-2.05a8.7 8.7 0 0 0 .913-.916l.346-.348-.034-.039a8.641 8.641 0 0 0 1.752-5.221Zm-2.841 2.841A8.627 8.627 0 0 0 5.83 3.279l.042-.042a7.71 7.71 0 0 1 11.449 10.312l-.055.065a7.917 7.917 0 0 1-.551.581 8.622 8.622 0 0 0 .455-2.744Z"
            data-name="路径 13711"
            transform="translate(-1539 -1382) translate(149 -167) translate(-14 2.909) translate(1415.989 1553.091)"
          />
        </g>
        <path
          d="M1421.629 1558.829a8.629 8.629 0 0 0-2.129 16.992v5.932l7.775-7.775a8.628 8.628 0 0 0-5.651-15.148Zm-.011 5.995v7.883l-2.266-1.307v-5.269l-2.267 1.309v-2.617l4.533-2.617 2.266 1.308Zm4.554 5.26-2.275 1.313v-5.247l2.275-1.315Z"
          data-name="路径 13712"
          transform="translate(-1539 -1382) translate(149 -167) translate(-14 2.909)"
        />
      </g>
    </SvgIcon>
  );
}

export function DiscordIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M18.9419 5.26946C17.6279 4.66787 16.2407 4.24108 14.8158 4C14.6208 4.34857 14.4443 4.70721 14.2872 5.0744C12.7694 4.84568 11.2258 4.84568 9.70801 5.0744C9.55079 4.70725 9.37437 4.34861 9.17946 4C7.75361 4.24312 6.3655 4.67092 5.05016 5.27261C2.43887 9.13606 1.73099 12.9036 2.08493 16.6176C3.61417 17.7474 5.32582 18.6067 7.14548 19.1581C7.55522 18.607 7.91778 18.0224 8.22933 17.4104C7.63759 17.1894 7.06646 16.9167 6.52255 16.5955C6.6657 16.4917 6.8057 16.3847 6.94098 16.2809C8.52364 17.0252 10.251 17.4111 12 17.4111C13.7489 17.4111 15.4763 17.0252 17.0589 16.2809C17.1958 16.3926 17.3358 16.4996 17.4774 16.5955C16.9324 16.9172 16.3602 17.1904 15.7675 17.412C16.0786 18.0236 16.4412 18.6078 16.8513 19.1581C18.6725 18.6089 20.3855 17.75 21.915 16.6191C22.3303 12.3121 21.2055 8.57919 18.9419 5.26946ZM8.67765 14.3335C7.69134 14.3335 6.87649 13.4384 6.87649 12.3372C6.87649 11.2361 7.66302 10.3332 8.6745 10.3332C9.68598 10.3332 10.4945 11.2361 10.4772 12.3372C10.4599 13.4384 9.68284 14.3335 8.67765 14.3335ZM15.3223 14.3335C14.3344 14.3335 13.5227 13.4384 13.5227 12.3372C13.5227 11.2361 14.3092 10.3332 15.3223 10.3332C16.3353 10.3332 17.1376 11.2361 17.1203 12.3372C17.103 13.4384 16.3275 14.3335 15.3223 14.3335Z" fill="white"/>
    </SvgIcon>
  );
}

export function Page404Icon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 536.196 278.5" {...props}>
      <defs>
        <clipPath id="a">
          <rect width="199" height="221" transform="translate(-0.01 -0.232)" />
        </clipPath>
        <clipPath id="c">
          <rect
            width="88"
            height="102"
            transform="translate(-0.128 0.155)"
            fill="#9fbfff"
          />
        </clipPath>
        <clipPath id="e">
          <rect
            width="100"
            height="102"
            transform="translate(0.258 0.482)"
            fill="#9fbfff"
          />
        </clipPath>
        <clipPath id="g">
          <rect width="533" height="9" transform="translate(-0.193 -0.366)" />
        </clipPath>
        <clipPath id="i">
          <rect width="10.948" height="31.019" />
        </clipPath>
        <clipPath id="j">
          <rect width="10.948" height="33.756" />
        </clipPath>
        <clipPath id="k">
          <rect width="21.896" height="88.04" />
        </clipPath>
        <clipPath id="l">
          <rect width="22.352" height="88.496" />
        </clipPath>
        <clipPath id="m">
          <rect width="17" height="22" transform="translate(0.469 0.337)" />
        </clipPath>
        <clipPath id="o">
          <rect width="18.703" height="46.073" />
        </clipPath>
        <clipPath id="p">
          <rect width="18.703" height="53.827" />
        </clipPath>
        <clipPath id="q">
          <rect width="28" height="94" transform="translate(0 0.411)" />
        </clipPath>
        <clipPath id="r">
          <rect width="28" height="193" transform="translate(0 0.411)" />
        </clipPath>
        <clipPath id="s">
          <rect width="9.123" height="25.089" />
        </clipPath>
        <clipPath id="t">
          <rect width="9.123" height="31.931" />
        </clipPath>
        <clipPath id="u">
          <rect width="32.388" height="80.74" />
        </clipPath>
        <clipPath id="v">
          <rect width="32.844" height="107.654" />
        </clipPath>
        <clipPath id="w">
          <rect width="45" height="36" />
        </clipPath>
        <clipPath id="x">
          <rect
            width="101"
            height="103"
            transform="translate(-0.298 0.14)"
            fill="#9fbfff"
          />
        </clipPath>
        <clipPath id="z">
          <rect width="24" height="24" />
        </clipPath>
      </defs>
      <g transform="translate(-987.402 -150)">
        <g transform="translate(1169.412 202.732)">
          <g clip-path="url(#a)">
            <g clip-path="url(#a)">
              <g transform="translate(0 -0.004)">
                <g transform="translate(51.377 25.27)">
                  <ellipse
                    cx="20.469"
                    cy="20.926"
                    rx="20.469"
                    ry="20.926"
                    transform="translate(0.722 0.722)"
                    fill="#fff"
                  />
                  <path
                    d="M133.819,98.683A21.653,21.653,0,1,1,155.01,77.035,21.448,21.448,0,0,1,133.819,98.683Zm0-41.852a20.21,20.21,0,1,0,19.746,20.2A20,20,0,0,0,133.819,56.831Z"
                    transform="translate(-112.627 -55.388)"
                    fill="#222433"
                  />
                </g>
                <g transform="translate(78.54)">
                  <path
                    d="M218.543,65.692l15.115-5.059a11.27,11.27,0,0,0,1.108-20.9L200.3,22.678c-.042-.918-.72-14.993-2.863-15.2-1.717-.177-2.694,2.139-3.251,4.945-3.115-6-7.219-11.992-9.681-10.645-2.288,1.275-.554,5.941,3.781,13.374-4.985-5.917-9.079-9.91-11.029-8.034s3.131,7.817,7.008,12.363c-3.781-1.732-8.814-4.281-10.066-2.6-1.83,2.405,2.384,4.763,5.009,6.591,5.8,4.065,6.983,4.33,7.3,8.8a7.21,7.21,0,0,0,5.894,6.056l16.482,9,.3.318a36.275,36.275,0,0,1,9.319,17.86Z"
                    transform="translate(-173.034 -0.858)"
                    fill="#fff"
                  />
                  <path
                    d="M217.683,65.548a.722.722,0,0,1-.708-.579l-.038-.186A35.506,35.506,0,0,0,207.8,47.278l-.226-.236L191.3,38.152a7.89,7.89,0,0,1-6.369-6.692c-.253-3.619-1-4.137-5.177-7.008-.548-.377-1.151-.792-1.814-1.257-.3-.209-.622-.426-.955-.649-2.09-1.406-4.46-3-4.774-4.894a2.622,2.622,0,0,1,.559-2.075c1.259-1.692,4.52-.533,8.006,1.029-4.3-5.18-6.837-8.989-4.873-10.878a2.383,2.383,0,0,1,1.818-.665c1.5.078,3.4,1.339,6.165,4.171-1.694-3.518-2.252-5.816-1.837-7.331A2.562,2.562,0,0,1,183.3.278a2.4,2.4,0,0,1,1.915-.157c2.671.812,5.81,5.707,7.869,9.437.8-2.6,2-3.829,3.573-3.667,1,.1,2.036,1.13,2.863,7.966.378,3.124.566,6.325.626,7.495l34.082,16.865a11.991,11.991,0,0,1-1.194,22.231l-15.12,5.062a.723.723,0,0,1-.228.037ZM174.729,16.163a.962.962,0,0,0-.807.281,1.211,1.211,0,0,0-.289.972c.212,1.281,2.4,2.751,4.155,3.932.339.228.668.449.976.664.661.463,1.261.876,1.806,1.251,4.332,2.983,5.5,3.783,5.8,8.094a6.488,6.488,0,0,0,5.3,5.4.721.721,0,0,1,.222.078l16.482,9a.721.721,0,0,1,.177.135l.3.318a36.946,36.946,0,0,1,9.375,17.6l14.345-4.8A10.548,10.548,0,0,0,233.6,39.518L199.123,22.457a.722.722,0,0,1-.4-.614c-.018-.387-.185-3.886-.59-7.4-.7-6.069-1.506-7-1.667-7.123-1.353-.074-2.1,2.7-2.426,4.37a.723.723,0,0,1-1.35.192c-3.082-5.936-6.036-9.818-7.9-10.384a.958.958,0,0,0-.795.039,1.135,1.135,0,0,0-.557.743c-.694,2.532,3.3,9.383,4.614,11.634a.722.722,0,0,1-1.177.828c-1.87-2.22-6.839-8.116-9.235-8.242a.922.922,0,0,0-.74.265c-.256.246-.63,1.15,1.4,4.237a79.481,79.481,0,0,0,5.607,7.084l.046.054a.722.722,0,0,1-.851,1.124c-.331-.152-.672-.31-1.019-.471C179.986,17.822,176.407,16.163,174.729,16.163Zm21.779-8.836Z"
                    transform="translate(-172.174 0.008)"
                    fill="#222433"
                  />
                </g>
                <path
                  d="M110.588,212.2l-3.459,19.376L62.82,248.85l18.013,46.23,57.313-22.321A24.789,24.789,0,0,0,153.581,254l3.571-19.984,16.561,8.438-18.229,33.338L201.526,295.3l28.03-51.546a24.772,24.772,0,0,0-10.547-33.939l-66.536-33.169"
                  transform="translate(-34.164 -96.06)"
                  fill="#fff"
                />
                <g transform="translate(37.205 80.822)">
                  <path
                    d="M140.5,299.085l-11.54,4.5q.384.02.772.02a15.084,15.084,0,0,0,10.769-4.519Z"
                    transform="translate(-107.339 -243.47)"
                    fill="none"
                  />
                  <path
                    d="M224.526,252.541a5.652,5.652,0,1,1,5.659-5.652A5.656,5.656,0,0,1,224.526,252.541ZM262.5,232.7l-7.8-7.962-8.019,8.01a4.51,4.51,0,0,1-6.381-6.374l11.246-11.233a4.51,4.51,0,0,1,6.43.048l10.981,11.233A4.5,4.5,0,1,1,262.5,232.7Zm5.105,25.857,18.928-18.906a3.42,3.42,0,0,1,5.37.649,17.252,17.252,0,0,1-23.647,23.62,3.424,3.424,0,0,1-.65-5.364Z"
                    transform="translate(-156.233 -197.099)"
                    fill="none"
                  />
                  <path
                    d="M356.574,409.757l-8.019,8.01a4.473,4.473,0,0,1-.9.69l8.534,3.616,4.444-8.173Z"
                    transform="translate(-226.272 -303.659)"
                    fill="none"
                  />
                  <path
                    d="M138.765,270.487a4.527,4.527,0,0,0-9.054,0,14.981,14.981,0,0,1-1.4,6.341l-.594,3.328-2.356.918a15.083,15.083,0,0,1-10.768,4.518q-.389,0-.772-.02l-12.705,4.951a24.168,24.168,0,0,0,37.655-20.036Z"
                    transform="translate(-92.192 -225.46)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M299.066,347.8a4.511,4.511,0,0,0,0-6.374l-6.641-6.633-4.509,8.245,4.768,4.763A4.524,4.524,0,0,0,299.066,347.8Z"
                    transform="translate(-193.784 -262.888)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M218.772,328.818h-.024a4.588,4.588,0,0,0-3.2,1.371l-4.672,4.787-4.816-4.811a4.538,4.538,0,0,0-6.406,0l-8.067,8.058a4.509,4.509,0,0,0,3.2,7.7,4.6,4.6,0,0,0,3.227-1.323l4.864-4.859,4.864,4.859a4.584,4.584,0,0,0,3.2,1.323h.024a4.589,4.589,0,0,0,3.2-1.371l4.672-4.787,2.252,2.249a24.784,24.784,0,0,0,1.553-5.256l.9-5.042-1.575-1.573A4.584,4.584,0,0,0,218.772,328.818Z"
                    transform="translate(-140.677 -259.641)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M98.947,373.366a4.5,4.5,0,0,0,1.3-3.223l-.144-11.137h11.342a4.522,4.522,0,1,0,0-9.044H95.527a4.52,4.52,0,0,0-4.5,4.57l.144,11.137H81.561l3.524,9.044h10.66a4.465,4.465,0,0,0,3.2-1.347Z"
                    transform="translate(-81.561 -271.14)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M166.523,390.88H166.5a4.588,4.588,0,0,0-3.2,1.371l-9.949,10.177,19.149-7.459-2.769-2.766A4.584,4.584,0,0,0,166.523,390.88Z"
                    transform="translate(-120.601 -293.393)"
                    fill="#9fbfff"
                  />
                  <ellipse
                    cx="5.659"
                    cy="5.652"
                    rx="5.659"
                    ry="5.652"
                    transform="translate(62.635 44.136)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M213.568,213.682c-.474,0-.942-.024-1.4-.068a52.045,52.045,0,0,1-3.845,4.859c-.813.925-1.513,1.95-2.374,2.833-.046.048-.1.091-.142.138a24.079,24.079,0,0,0,7.766,1.282,4.522,4.522,0,1,0,0-9.044Z"
                    transform="translate(-149.128 -196.989)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M292.931,226.42,281.95,215.187a4.51,4.51,0,0,0-6.43-.048l-11.246,11.233a4.51,4.51,0,1,0,6.381,6.374l8.019-8.01,7.8,7.962a4.5,4.5,0,1,0,6.454-6.278Z"
                    transform="translate(-180.208 -197.099)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M255.479,182.894a5.657,5.657,0,0,0,4.91-2.845l-5.657-2.88-4.764,1.355A5.658,5.658,0,0,0,255.479,182.894Z"
                    transform="translate(-173.147 -177.169)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M397.825,338.929a4.519,4.519,0,0,0,4.527,4.522h1.591l4.918-9.044h-6.509a4.519,4.519,0,0,0-4.527,4.522Z"
                    transform="translate(-253.556 -262.681)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M348.47,396.738l4.059,4.142,4.5-8.282-5.287-5.409a4.488,4.488,0,0,0-3.2-1.371h-.024a4.541,4.541,0,0,0-3.2,1.323L334.07,398.374a4.5,4.5,0,0,0-1.19,4.237l6.67,2.827a4.476,4.476,0,0,0,.9-.69Z"
                    transform="translate(-218.168 -290.64)"
                    fill="#9fbfff"
                  />
                  <path
                    d="M346.158,290.858a17.246,17.246,0,0,0,2.649-20.974,3.42,3.42,0,0,0-5.37-.649L324.509,288.14a3.424,3.424,0,0,0,.65,5.364A17.266,17.266,0,0,0,346.158,290.858Z"
                    transform="translate(-213.135 -226.684)"
                    fill="#9fbfff"
                  />
                </g>
                <path
                  d="M46.428,381.165l-9.392,3.873a5.158,5.158,0,0,0-3.2,5.147h0a5.2,5.2,0,0,0,5.177,4.835h5.755a7.21,7.21,0,0,1,7.224,7.216v.241H19.915L0,345.422l28.416-10.487,18.013,46.23"
                  transform="translate(0 -182.145)"
                  fill="#3d3fea"
                />
                <path
                  d="M248.117,393.991,294.159,413.5h0a7.767,7.767,0,0,0,6.815,11.5h7.2a7.789,7.789,0,0,1,7.658,6.374l.6,3.223h-49.92L233.6,420.955Z"
                  transform="translate(-127.038 -214.262)"
                  fill="#3d3fea"
                />
                <path
                  d="M200.136,295.156a.722.722,0,0,1-.282-.057l-46.043-19.507a.721.721,0,0,1-.352-1.01L171.332,241.9l-15.031-7.66-3.4,19.026a25.649,25.649,0,0,1-15.885,19.307L79.7,294.89a.723.723,0,0,1-.936-.412l-18.013-46.23a.721.721,0,0,1,.411-.934L105.1,230.191l3.389-18.976a.722.722,0,0,1,1.422.254l-3.459,19.374a.722.722,0,0,1-.449.546L62.365,248.4l17.489,44.886,56.639-22.059a24.2,24.2,0,0,0,14.987-18.216l3.57-19.984a.723.723,0,0,1,1.04-.516l16.561,8.438a.721.721,0,0,1,.306.989l-17.847,32.639,44.7,18.94,27.717-50.97a24.05,24.05,0,0,0-10.24-32.951L150.76,176.425a.722.722,0,1,1,.645-1.291L217.941,208.3a25.493,25.493,0,0,1,10.859,34.93l-28.03,51.546a.723.723,0,0,1-.634.377Z"
                  transform="translate(-33.014 -95.199)"
                  fill="#222433"
                />
                <path
                  d="M303.26,310.733a.757.757,0,0,1-.1-.007.722.722,0,0,1-.618-.621l-1.108-8.419a.723.723,0,0,1,1.433-.188l.764,5.807,1.949-4.553a.722.722,0,0,1,1.328.567l-2.986,6.975A.722.722,0,0,1,303.26,310.733Z"
                  transform="translate(-163.928 -163.62)"
                  fill="#222433"
                />
                <g transform="translate(44.393 45.169)">
                  <path
                    d="M139.616,108.191l20.247-6.87A13.553,13.553,0,0,1,177.1,109.86l.939,2.814a9.9,9.9,0,0,1-6.213,12.532l-.478.162.5,9.916-.563.189c-20.749,11.453-19.823,35.891-47.96,35.891l-3.846-29.314-.024-.043-16.286,5.544L98.9,128.8l5.3-9.381Z"
                    transform="translate(-98.18 -99.872)"
                    fill="#fff"
                  />
                  <path
                    d="M122.471,171.225a.722.722,0,0,1-.716-.628l-3.738-28.489-15.469,5.265a.723.723,0,0,1-.937-.523L97.336,128.1a.721.721,0,0,1,.075-.515l5.3-9.381a.722.722,0,0,1,.411-.333l35.41-11.226,20.24-6.868a14.275,14.275,0,0,1,18.16,8.994l.939,2.814a10.648,10.648,0,0,1-6.627,13.43l.474,9.372a.722.722,0,0,1-.491.722l-.5.168c-8.108,4.494-12.843,11.006-17.422,17.3C146.33,162.167,139.744,171.225,122.471,171.225Zm-3.87-30.8a.723.723,0,0,1,.628.364l.024.043a.721.721,0,0,1,.089.265l3.763,28.681c16.06-.212,22.076-8.485,29.028-18.046,4.683-6.441,9.526-13.1,17.949-17.751a.715.715,0,0,1,.12-.052l.044-.015-.474-9.37a.722.722,0,0,1,.489-.72l.478-.162a9.2,9.2,0,0,0,5.76-11.619l-.939-2.814a12.83,12.83,0,0,0-16.323-8.084l-20.248,6.87-.014,0-35.145,11.143-5.021,8.891,4.034,17.7,15.526-5.285a.727.727,0,0,1,.233-.038Zm20.154-33.094Z"
                    transform="translate(-97.318 -99.011)"
                    fill="#222433"
                  />
                </g>
                <path
                  d="M148.664,194.389a.72.72,0,0,1-.361-.1l-5.515-3.175a.722.722,0,1,1,.722-1.251l5.515,3.175a.721.721,0,0,1-.361,1.347Z"
                  transform="translate(-77.456 -103.2)"
                  fill="#222433"
                />
                <path
                  d="M256.544,148.848a.722.722,0,0,1-.721-.683l-.265-4.931a.723.723,0,0,1,1.443-.077l.265,4.931a.722.722,0,0,1-.683.759Z"
                  transform="translate(-138.981 -77.478)"
                  fill="#222433"
                />
                <path
                  d="M209.347,182.415a.721.721,0,0,1-.222-1.409c2.7-.872,4.768-3.345,7.158-6.209,2.751-3.3,5.869-7.033,10.751-9.068a.722.722,0,1,1,.556,1.332c-4.554,1.9-7.552,5.491-10.2,8.659-2.428,2.91-4.721,5.658-7.823,6.658a.721.721,0,0,1-.222.036Z"
                  transform="translate(-113.457 -90.095)"
                  fill="#222433"
                />
                <path
                  d="M204.121,191.9a.721.721,0,0,1-.225-1.408,9.022,9.022,0,0,0,3.825-2.8.722.722,0,0,1,1.084.954,10.4,10.4,0,0,1-4.458,3.215.723.723,0,0,1-.225.036Z"
                  transform="translate(-110.615 -101.938)"
                  fill="#222433"
                />
                <path
                  d="M216.21,31.91a.69.69,0,0,1-.073,0,.722.722,0,0,1-.646-.79l.674-6.687a.722.722,0,0,1,1.438.144l-.674,6.687A.722.722,0,0,1,216.21,31.91Z"
                  transform="translate(-117.189 -12.929)"
                  fill="#222433"
                />
                <path
                  d="M200.479,60.126h-.024a.722.722,0,0,1-.7-.746l.144-4.426a.723.723,0,0,1,1.445.047l-.144,4.426A.722.722,0,0,1,200.479,60.126Z"
                  transform="translate(-108.635 -29.502)"
                  fill="#222433"
                />
                <path
                  d="M89.146,168.805a.722.722,0,0,1-.622-1.088l4.046-6.855a.722.722,0,0,1,1.245.733l-4.046,6.855a.723.723,0,0,1-.623.355Z"
                  transform="translate(-48.088 -87.285)"
                  fill="#222433"
                />
                <path
                  d="M184.77,56.523a.722.722,0,0,1-.722-.706,9.552,9.552,0,0,0-.714-3.433A12.161,12.161,0,0,0,179.9,47.47a.722.722,0,1,1,.93-1.1,13.532,13.532,0,0,1,3.84,5.47,10.986,10.986,0,0,1,.821,3.95.722.722,0,0,1-.707.737Z"
                  transform="translate(-97.697 -25.119)"
                  fill="#222433"
                />
                <path
                  d="M144.948,66.472l0,0a.543.543,0,0,1,.053.149l2.832,14.307a.551.551,0,0,0,.328.4l8.084,3.374a3.822,3.822,0,0,0,5.2-4.378l-.795-3.44L159.471,70.9a.552.552,0,0,1,.248-.569,10.331,10.331,0,0,0,2.836-14.666.524.524,0,0,1-.058-.106l-.556-1.371c-.024-.059-.841-.468-.841-.532a7.46,7.46,0,0,0-.722-3.127A19.529,19.529,0,0,0,156.284,45l-1-1.521a.552.552,0,0,0-.465-.1l-8.89,2.049a.551.551,0,0,0-.361.277l-3.695,6.919a.554.554,0,0,0-.056.161l-.427,2.345a.551.551,0,0,1-.217.345l-2.231,2.516c-.127.093-.949.565-.963.722l-.393.894c-.31,3.3,1.338,6.528,5.146,6.8a.6.6,0,0,0,.124,0l1.523-.215A.552.552,0,0,1,144.948,66.472Z"
                  transform="translate(-74.807 -23.577)"
                  fill="#fff"
                />
                <ellipse
                  cx="0.843"
                  cy="0.842"
                  rx="0.843"
                  ry="0.842"
                  transform="translate(84.5 27.015)"
                  fill="#222433"
                />
                <g transform="translate(82.432 27.208)">
                  <path
                    d="M182.284,61.218l4.214,2.959a1.018,1.018,0,0,1,.241,1.443l-1.276,1.732"
                    transform="translate(-181.564 -60.497)"
                    fill="#fff"
                  />
                  <path
                    d="M184.6,67.214a.722.722,0,0,1-.581-1.15l1.276-1.732a.3.3,0,0,0-.072-.424l-4.214-2.959a.722.722,0,1,1,.831-1.181l4.214,2.959a1.738,1.738,0,0,1,.407,2.462l-1.276,1.732A.723.723,0,0,1,184.6,67.214Z"
                    transform="translate(-180.706 -59.638)"
                    fill="#222433"
                  />
                </g>
                <ellipse
                  cx="0.843"
                  cy="0.842"
                  rx="0.843"
                  ry="0.842"
                  transform="translate(77.733 28.337)"
                  fill="#222433"
                />
                <path
                  d="M185.194,80.992l.578-1.13a1.824,1.824,0,0,1,2.914-.457l.554.553a.784.784,0,0,1,.217.746h0a.8.8,0,0,1-1.2.481l-.169-.12a.812.812,0,0,0-1.108.216l-.385.553a.8.8,0,0,1-1.156.168l-.048-.024A.841.841,0,0,1,185.194,80.992Z"
                  transform="translate(-100.67 -42.888)"
                  fill="#222433"
                />
                <path
                  d="M171.625,104.624q-.547,0-1.095-.054a.722.722,0,1,1,.141-1.436,9.651,9.651,0,0,0,5.915-1.32.722.722,0,1,1,.743,1.238A11.085,11.085,0,0,1,171.625,104.624Z"
                  transform="translate(-92.386 -55.31)"
                  fill="#222433"
                />
                <path
                  d="M165.435,99.83a4.543,4.543,0,0,1-1.761-.356l-8.355-3.488a.722.722,0,0,1-.43-.526l-2.884-14.569q-.092-.173-.177-.351a.722.722,0,0,1,1.3-.627q.1.2.2.39a.71.71,0,0,1,.072.2l2.83,14.3,8,3.339a3.1,3.1,0,0,0,4.219-3.55l-.795-3.44-1.263-6.382a.721.721,0,0,1,.339-.76,9.672,9.672,0,0,0,4.712-8.268,9.54,9.54,0,0,0-1.806-5.6.722.722,0,0,1,1.173-.842,10.971,10.971,0,0,1,2.076,6.446,11.124,11.124,0,0,1-4.98,9.236l1.162,5.873.79,3.417a4.547,4.547,0,0,1-4.425,5.561Z"
                  transform="translate(-82.537 -37.518)"
                  fill="#222433"
                />
                <g transform="translate(60.022 16.102)">
                  <path
                    d="M143.062,53.489c1.6-.716,10.95-11.449,10.95-11.449l3.98,3.423c-.974-2.808-2.321-5.25-4.868-6.776h0a12.9,12.9,0,0,0-17.68,4.442,13.037,13.037,0,0,0-2.256,7.475"
                    transform="translate(-132.442 -36.144)"
                    fill="#fff"
                  />
                  <path
                    d="M142.2,53.358a.721.721,0,0,1-.3-1.38c1-.449,6.86-6.857,10.7-11.264a.723.723,0,0,1,1.016-.072l1.587,1.365a9.124,9.124,0,0,0-3.318-3.555A12.19,12.19,0,0,0,135.2,42.646c-1.625,2.714-2.31,4.955-2.155,7.052a.722.722,0,0,1-1.441.106c-.177-2.408.572-4.918,2.357-7.9a13.637,13.637,0,0,1,18.67-4.69c3.018,1.809,4.354,4.778,5.18,7.162a.722.722,0,0,1-1.154.783L153.221,42.2c-2.3,2.619-9.2,10.406-10.726,11.092A.721.721,0,0,1,142.2,53.358Z"
                    transform="translate(-131.579 -35.29)"
                    fill="#222433"
                  />
                </g>
                <g transform="translate(6.964 9.554)">
                  <path
                    d="M54.266,86.2,67.511,63.787l-.039-.087c3.063-1.311,4.925-4.974,4.181-7.85-1.108-4.354-4.888-8.755-.674-14.432,1.926-2.55,5.153-6.109,2.673-7.817-1.71-1.179-5.683,2.814-8.717,5.652,2.24-5.532,5.177-12.8,2.721-13.951-2.432-1.155-5.057,3.921-7.9,11.113,1.734-8.419,1.926-13.4-.65-13.879-4.238-.794-6.67,16.092-6.67,22.418,0,2.67.044,4.741.1,6.251L19.4,93.853a11.266,11.266,0,0,0,8.741,18.4,12.486,12.486,0,0,0,3.636-.577L58.013,102.7Z"
                    transform="translate(-16.126 -21.791)"
                    fill="#fff"
                  />
                  <path
                    d="M27.278,112.12a11.988,11.988,0,0,1-9.3-19.579l32.962-42.43c-.058-1.8-.087-3.823-.087-6.013,0-4.957,1.675-19.387,5.447-22.514a2.467,2.467,0,0,1,2.079-.614,2.553,2.553,0,0,1,1.7,1.135c.869,1.293,1.066,3.653.574,7.551,1.719-3.563,3.125-5.362,4.527-5.915a2.37,2.37,0,0,1,1.928.053c2.461,1.156,1.206,5.737-1.167,11.869,2.815-2.582,5.539-4.7,7.264-3.512a2.627,2.627,0,0,1,1.18,1.8c.3,1.915-1.472,4.191-3.034,6.2-.227.292-.447.575-.653.847-2.968,4-1.688,7.2-.332,10.6a26.57,26.57,0,0,1,1.13,3.221c.819,3.164-1.112,6.982-4.249,8.531L54.174,85.468l3.683,16.221a.721.721,0,0,1-.471.842L31.148,111.5a13.235,13.235,0,0,1-3.87.618ZM57.957,22.374a1.147,1.147,0,0,0-.733.321c-2.895,2.4-4.926,15.318-4.926,21.4,0,2.282.032,4.378.1,6.226a.721.721,0,0,1-.151.467L19.107,93.439a10.545,10.545,0,0,0,8.171,17.238,11.754,11.754,0,0,0,3.425-.546l25.6-8.755L52.7,85.508a.721.721,0,0,1,.083-.526L65.89,62.8a.722.722,0,0,1,.436-.618c2.676-1.145,4.436-4.42,3.767-7.007a25.044,25.044,0,0,0-1.072-3.044c-1.376-3.444-2.935-7.348.517-12,.213-.282.438-.571.669-.868,1.313-1.69,2.948-3.793,2.747-5.093a1.209,1.209,0,0,0-.572-.832c-1.089-.752-4.969,2.906-7.054,4.871-.258.243-.512.483-.76.714a.722.722,0,0,1-1.164-.8A79.43,79.43,0,0,0,66.5,29.594c.961-3.6.313-4.343-.01-4.5a.912.912,0,0,0-.781-.015c-2.011.792-4.466,6.509-6.138,10.74a.722.722,0,0,1-1.38-.41c.527-2.561,2.132-10.353.687-12.5a1.127,1.127,0,0,0-.762-.521.853.853,0,0,0-.156-.015Z"
                    transform="translate(-15.266 -20.936)"
                    fill="#222433"
                  />
                </g>
                <path
                  d="M142.665,82.1A5.774,5.774,0,1,1,145.9,71.538a.722.722,0,1,1-.809,1.2,4.332,4.332,0,1,0-.948,7.663.722.722,0,1,1,.492,1.357A5.769,5.769,0,0,1,142.665,82.1Z"
                  transform="translate(-74.444 -38.364)"
                  fill="#222433"
                />
                <path
                  d="M94.055,90.114h-.011a.722.722,0,0,1-.712-.732l.072-4.838a.723.723,0,0,1,1.445.021L94.777,89.4A.722.722,0,0,1,94.055,90.114Z"
                  transform="translate(-50.758 -45.587)"
                  fill="#222433"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(1407.53 196.345)">
          <g clip-path="url(#c)">
            <g clip-path="url(#c)">
              <path
                d="M88.19,37.875a91.052,91.052,0,0,1-1.841,18.1,72.212,72.212,0,0,1-5.911,17.3,63.064,63.064,0,0,1-9.748,14.61A41.809,41.809,0,0,1,56.614,98.021a43.238,43.238,0,0,1-18.2,3.827q-16.8,0-26.754-9.929Q1.7,82.028,1.7,65.13a89.517,89.517,0,0,1,1.841-18.1A73.176,73.176,0,0,1,9.379,29.937a59.159,59.159,0,0,1,9.748-14.48A42.914,42.914,0,0,1,33.2,5.45,43.994,43.994,0,0,1,51.351,1.7q17.071,0,26.962,9.516T88.19,37.875ZM49.64,22.981q-8.127,0-12.936,7.654-3.694,5.818-6.2,16.523a83.568,83.568,0,0,0-2.489,18.514c0,9.826,4.3,14.765,12.936,14.765a13.078,13.078,0,0,0,11.8-6.671q3.966-6.4,6.689-17.454a83.928,83.928,0,0,0,2.7-19.445Q62.174,22.981,49.64,22.981Z"
                transform="translate(-0.927 -0.925)"
                fill="#9fbfff"
              />
              <path
                d="M37.487,101.724c-11.355,0-20.532-3.413-27.3-10.162S0,75.608,0,64.2A89.209,89.209,0,0,1,1.867,45.949,74.7,74.7,0,0,1,7.752,28.676a60.664,60.664,0,0,1,9.877-14.661A43.823,43.823,0,0,1,31.965,3.827,44.667,44.667,0,0,1,50.424,0C61.96,0,71.215,3.284,77.93,9.722c6.715,6.464,10.137,15.618,10.137,27.228A90.714,90.714,0,0,1,86.2,55.206a73.893,73.893,0,0,1-5.963,17.506A63.281,63.281,0,0,1,70.36,87.5,43.131,43.131,0,0,1,56.023,97.846,44.824,44.824,0,0,1,37.487,101.724ZM50.424,1.551A42.926,42.926,0,0,0,18.77,15.075,58.729,58.729,0,0,0,9.151,29.348,73.271,73.271,0,0,0,3.37,46.259,89.853,89.853,0,0,0,1.555,64.2c0,10.99,3.267,19.833,9.722,26.271s15.27,9.7,26.184,9.7a42.963,42.963,0,0,0,17.888-3.749,41.623,41.623,0,0,0,13.818-9.955A62.031,62.031,0,0,0,78.785,72.04a72.194,72.194,0,0,0,5.833-17.118,89.331,89.331,0,0,0,1.841-17.945c0-11.171-3.241-19.962-9.644-26.116C70.438,4.68,61.545,1.551,50.424,1.551Zm-10.4,78.737c-9.1,0-13.714-5.223-13.714-15.54a85.034,85.034,0,0,1,2.515-18.7c1.659-7.188,3.785-12.825,6.3-16.782,3.37-5.327,7.933-8.016,13.61-8.016,8.814,0,13.3,4.939,13.3,14.687a84.279,84.279,0,0,1-2.722,19.626c-1.815,7.421-4.1,13.368-6.792,17.687A13.926,13.926,0,0,1,40.028,80.288Zm8.685-57.456c-5.159,0-9.177,2.379-12.288,7.292-2.411,3.8-4.459,9.283-6.092,16.29a83.461,83.461,0,0,0-2.463,18.333c0,9.412,3.992,13.989,12.159,13.989a12.29,12.29,0,0,0,11.148-6.309C53.768,68.264,56,62.472,57.76,55.206a82.363,82.363,0,0,0,2.67-19.264C60.457,27.125,56.62,22.832,48.713,22.832Z"
                fill="#9fbfff"
              />
            </g>
          </g>
        </g>
        <g transform="translate(1401.143 309.018)">
          <g clip-path="url(#e)">
            <g clip-path="url(#e)">
              <g transform="translate(0.01)">
                <path
                  d="M100.507,58.093,95.833,81.018H77.61l-4.674,21.771h-28.8l4.543-21.771H1.727L7.425,55.6,65.191,1.725H94.284L82.6,58.093Zm-46.134,0L57,46.106q1.891-9.049,4.385-18.545a133.534,133.534,0,0,1-11.4,12.276L39.012,50.513a73.528,73.528,0,0,1-9.059,7.9c2.442-.184,5.251-.289,8.481-.289H54.373Z"
                  transform="translate(-0.949 -0.938)"
                  fill="#9fbfff"
                />
                <path
                  d="M72.009,102.638H43.2a.781.781,0,0,1-.761-.944l4.332-20.827H.8a.747.747,0,0,1-.6-.289.83.83,0,0,1-.158-.656l5.7-25.417a.622.622,0,0,1,.236-.393L63.712.21A.834.834,0,0,1,64.237,0H93.33a.747.747,0,0,1,.6.289.741.741,0,0,1,.158.656l-11.5,55.424H99.527a.781.781,0,0,1,.761.944L95.667,80.264a.784.784,0,0,1-.761.63H77.339l-4.569,21.141A.788.788,0,0,1,72.009,102.638Zm-27.833-1.574h27.2l4.543-21.141a.784.784,0,0,1,.761-.63H94.249l4.359-21.351H81.646A.781.781,0,0,1,80.884,57l11.5-55.424H64.552L7.206,55.083,1.771,79.319h45.95a.781.781,0,0,1,.761.944ZM29.026,58.23a.765.765,0,0,1-.735-.525.784.784,0,0,1,.289-.918A71.561,71.561,0,0,0,37.533,49L48.509,38.322a135.558,135.558,0,0,0,11.343-12.2.8.8,0,0,1,.972-.21.747.747,0,0,1,.394.892c-1.654,6.3-3.125,12.512-4.385,18.518L54.207,57.312a.784.784,0,0,1-.761.63H37.507c-3.177,0-6.013.1-8.429.289ZM58.828,29.8c-2.836,3.279-5.934,6.531-9.243,9.679L38.636,50.125A88,88,0,0,1,31.6,56.5c1.812-.079,3.781-.131,5.908-.131H52.789l2.494-11.358C56.334,40.079,57.515,34.965,58.828,29.8Z"
                  transform="translate(-0.022)"
                  fill="#9fbfff"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(990.595 419.866)">
          <g transform="translate(0)" clip-path="url(#g)">
            <g clip-path="url(#g)">
              <g transform="translate(1.201 2.274)">
                <path
                  d="M526.905,6.461H3.653c-.6,0-1.021-.307-1.021-.738s.42-.738,1.021-.738H526.905c.6,0,1.021.307,1.021.738S527.386,6.461,526.905,6.461Z"
                  transform="translate(-2.632 -4.986)"
                  fill="#222433"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(1015.402 391.422)">
          <g
            transform="matrix(0.993, 0.116, -0.116, 0.993, 3.592, 0)"
            clip-path="url(#i)"
          >
            <g clip-path="url(#j)">
              <ellipse
                cx="4.79"
                cy="4.785"
                rx="4.79"
                ry="4.785"
                transform="translate(0.684 0.684)"
                fill="#fff"
              />
              <path
                d="M5.474,10.936a5.468,5.468,0,1,1,5.474-5.468A5.477,5.477,0,0,1,5.474,10.936Zm0-9.569a4.1,4.1,0,1,0,4.106,4.1A4.108,4.108,0,0,0,5.474,1.367Z"
                fill="#222433"
              />
              <g transform="translate(4.79 4.785)">
                <path
                  d="M.684,28.972A.684.684,0,0,1,0,28.288V.684a.684.684,0,0,1,1.369,0v27.6A.684.684,0,0,1,.684,28.972Z"
                  fill="#222433"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(1367.698 333.333)">
          <g
            transform="matrix(0.987, 0.163, -0.163, 0.987, 14.349, 0)"
            clip-path="url(#k)"
          >
            <g clip-path="url(#l)">
              <g transform="translate(0 0)">
                <path
                  d="M5.9,85.346a.711.711,0,0,1-.708-.669L0,.757A.71.71,0,1,1,1.419.669l5.187,83.92a.712.712,0,0,1-.665.756Z"
                  transform="translate(9.271 3.149)"
                  fill="#222433"
                />
                <ellipse
                  cx="5.407"
                  cy="5.428"
                  rx="5.407"
                  ry="5.428"
                  transform="translate(4.671 0)"
                  fill="#82b1ff"
                />
                <ellipse
                  cx="5.407"
                  cy="5.428"
                  rx="5.407"
                  ry="5.428"
                  transform="translate(10.794 11.387)"
                  fill="#82b1ff"
                />
                <ellipse
                  cx="5.407"
                  cy="5.428"
                  rx="5.407"
                  ry="5.428"
                  transform="translate(0 12.057)"
                  fill="#82b1ff"
                />
                <ellipse
                  cx="5.407"
                  cy="5.428"
                  rx="5.407"
                  ry="5.428"
                  transform="translate(11.537 23.42)"
                  fill="#82b1ff"
                />
                <ellipse
                  cx="5.407"
                  cy="5.428"
                  rx="5.407"
                  ry="5.428"
                  transform="translate(0.743 24.093)"
                  fill="#82b1ff"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(1392.932 401.163)">
          <g clip-path="url(#m)">
            <g clip-path="url(#m)">
              <g transform="translate(9.656)">
                <ellipse
                  cx="3.415"
                  cy="3.41"
                  rx="3.415"
                  ry="3.41"
                  transform="translate(0.652 0.652)"
                  fill="#fff"
                />
                <path
                  d="M25.236,8.124A4.062,4.062,0,1,1,29.3,4.062a4.065,4.065,0,0,1-4.067,4.062Zm0-6.821A2.759,2.759,0,1,0,28,4.062,2.76,2.76,0,0,0,25.236,1.3Z"
                  transform="translate(-21.169)"
                  fill="#222433"
                />
              </g>
              <g transform="translate(0 4.801)">
                <ellipse
                  cx="2.697"
                  cy="2.694"
                  rx="2.697"
                  ry="2.694"
                  transform="translate(0.652 0.652)"
                  fill="#fff"
                />
                <path
                  d="M3.349,17.214A3.345,3.345,0,1,1,6.7,13.869a3.347,3.347,0,0,1-3.349,3.345Zm0-5.387a2.042,2.042,0,1,0,2.044,2.042,2.043,2.043,0,0,0-2.044-2.042Z"
                  transform="translate(0 -10.524)"
                  fill="#222433"
                />
              </g>
              <path
                d="M18.245,26.417a.652.652,0,0,1-.628-.831L22.663,7.948a.652.652,0,0,1,1.255.358L18.872,25.945a.652.652,0,0,1-.627.473Z"
                transform="translate(-9.567 -4.065)"
                fill="#222433"
              />
              <path
                d="M11.892,31.286a.652.652,0,0,1-.607-.413L5.957,17.319a.653.653,0,0,1,1.214-.478L12.5,30.4a.652.652,0,0,1-.607.891Z"
                transform="translate(-3.215 -8.934)"
                fill="#222433"
              />
            </g>
          </g>
        </g>
        <g transform="translate(1499.105 376.461)">
          <g
            transform="matrix(0.992, 0.129, -0.129, 0.992, 5.947, 0)"
            clip-path="url(#o)"
          >
            <g clip-path="url(#p)">
              <g transform="translate(0 0)">
                <path
                  d="M.754,40.505a.469.469,0,0,1-.05,0,.765.765,0,0,1-.7-.819L2.541.719a.754.754,0,1,1,1.5.1L1.506,39.787a.761.761,0,0,1-.752.718Z"
                  transform="translate(5.53 13.322)"
                  fill="#222433"
                />
                <path
                  d="M.755,5.186a.754.754,0,0,1-.7-.486.781.781,0,0,1,.185-.845L4.04.209A.743.743,0,0,1,5.106.243a.782.782,0,0,1-.033,1.089l-3.8,3.646A.743.743,0,0,1,.755,5.186Z"
                  transform="translate(8.616 1.489)"
                  fill="#222433"
                />
                <path
                  d="M4.066,6.675a.748.748,0,0,1-.582-.281L.172,2.288A.781.781,0,0,1,.275,1.2a.744.744,0,0,1,1.062.1l2.1,2.609.207-3.2a.754.754,0,1,1,1.5.1L4.819,5.955a.761.761,0,0,1-.752.719Z"
                  transform="translate(5.304 0)"
                  fill="#222433"
                />
                <path
                  d="M15.234,10.19l.151-2.336A8.927,8.927,0,0,1,17.7,2.387l1.006-1.1L0,0,.855,1.232A8.927,8.927,0,0,1,2.438,6.956L2.288,9.292a6.564,6.564,0,0,0,6.033,7.033h0a6.376,6.376,0,0,0,4.705-1.6A6.648,6.648,0,0,0,15.234,10.19Z"
                  transform="translate(0 5.262)"
                  fill="#82b1ff"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(987.402 329.089)">
          <g clip-path="url(#q)">
            <g clip-path="url(#r)">
              <g transform="translate(0 -0.046)">
                <path
                  d="M41.388,218.237a.774.774,0,0,1-.77-.733L31.224,47.3a.773.773,0,1,1,1.543-.086l9.394,170.2a.775.775,0,0,1-.729.818Z"
                  transform="translate(-16.98 -25.232)"
                  fill="#222433"
                />
                <path
                  d="M25.418.716a2.8,2.8,0,0,0-3.167,2.379,2.8,2.8,0,1,0-5.537-.776L14.68,16.441,10.92,2.681A2.8,2.8,0,1,0,5.461,3.923a.758.758,0,0,1,.052.233,2.826,2.826,0,0,0-3.4-2.043A2.841,2.841,0,0,0,.079,5.526c0,.026.026.052.026.078l.489,1.81,3.3,12.208a11.242,11.242,0,0,0,9.142,8.225v.026h0a12.424,12.424,0,0,0,4.687-.285h0v-.026a11.339,11.339,0,0,0,8.06-9.311L27.53,5.733l.258-1.862A2.742,2.742,0,0,0,25.418.715Z"
                  transform="translate(0.001 0.101)"
                  fill="#82b1ff"
                />
                <path
                  d="M13.935,19.31a.773.773,0,0,1-.745-.573L10.306,8.055A.773.773,0,1,1,11.8,7.649L14.68,18.332a.776.776,0,0,1-.544.952A.762.762,0,0,1,13.935,19.31Z"
                  transform="translate(-5.59 -3.802)"
                  fill="#222433"
                />
                <path
                  d="M44.585,17.269a.774.774,0,0,1-.766-.885L45.364,5.419a.773.773,0,1,1,1.53.217L45.349,16.6A.774.774,0,0,1,44.585,17.269Z"
                  transform="translate(-23.826 -2.538)"
                  fill="#222433"
                />
                <path
                  d="M22.087,83.462A.771.771,0,0,1,21.5,83.2L10.921,71.014a.778.778,0,0,1,.074-1.1.77.77,0,0,1,1.09.074L22.669,82.175a.776.776,0,0,1-.582,1.286Z"
                  transform="translate(-5.835 -37.874)"
                  fill="#222433"
                />
                <path
                  d="M34.7,81.612a.776.776,0,0,1-.655-1.186l8.5-13.734a.773.773,0,1,1,1.312.819l-8.5,13.734a.772.772,0,0,1-.657.366Z"
                  transform="translate(-18.453 -36.024)"
                  fill="#222433"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(1140.59 397.559)">
          <g
            transform="matrix(0.994, 0.112, -0.112, 0.994, 2.818, 0)"
            clip-path="url(#s)"
          >
            <g clip-path="url(#t)">
              <g transform="translate(3.91 3.96)">
                <path
                  d="M.652,27.972A.656.656,0,0,1,0,27.312V.66A.656.656,0,0,1,.652,0,.656.656,0,0,1,1.3.66V27.312A.656.656,0,0,1,.652,27.972Z"
                  fill="#222433"
                />
              </g>
              <ellipse
                cx="4.562"
                cy="4.619"
                rx="4.562"
                ry="4.619"
                fill="#82b1ff"
              />
            </g>
          </g>
        </g>
        <g transform="translate(1022.635 337.72)">
          <g
            transform="matrix(0.948, -0.317, 0.317, 0.948, 0, 10.262)"
            clip-path="url(#u)"
          >
            <g clip-path="url(#v)">
              <g transform="translate(0 0)">
                <g transform="translate(10.786 7.62)">
                  <path
                    d="M15.019,24.157l-8.363,5L1.648,20.807A11.5,11.5,0,0,1,5.585,5.021L5.617,5l8.363-5,5.009,8.352a11.5,11.5,0,0,1-3.937,15.786Z"
                    transform="translate(0.71 0.709)"
                    fill="#fff"
                  />
                  <path
                    d="M7.366,30.577a.71.71,0,0,1-.608-.344L1.749,21.88A12.2,12.2,0,0,1,5.929,5.123L5.961,5.1l8.363-5A.71.71,0,0,1,15.3.344L20.306,8.7a12.2,12.2,0,0,1-4.18,16.757l-.032.019h0l-8.363,5a.712.712,0,0,1-.365.1Zm7.078-28.9L6.664,6.334a10.787,10.787,0,0,0-3.7,14.816L7.61,28.9,15.4,24.239A10.787,10.787,0,0,0,19.089,9.426Zm1.284,23.185Z"
                    transform="translate(0)"
                    fill="#222433"
                  />
                </g>
                <path
                  d="M.71,84.346a.718.718,0,0,1-.173-.021.709.709,0,0,1-.516-.86L20.847.537a.71.71,0,0,1,1.377.345L1.4,83.81A.709.709,0,0,1,.71,84.346Z"
                  transform="translate(0 23.308)"
                  fill="#222433"
                />
                <path
                  d="M.71,8.941a.718.718,0,0,1-.173-.021.709.709,0,0,1-.516-.86L1.911.536A.709.709,0,0,1,3.287.881L1.4,8.4A.709.709,0,0,1,.71,8.941Z"
                  transform="translate(24.765 0.097)"
                  fill="#222433"
                />
                <path
                  d="M2.053,9.038a.709.709,0,0,1-.7-.586L.011.832a.709.709,0,0,1,1.4-.246L2.753,8.206a.709.709,0,0,1-.7.832Z"
                  transform="translate(23.421)"
                  fill="#222433"
                />
                <path
                  d="M.709,7.475A.709.709,0,0,1,.153,6.327L4.969.25a.709.709,0,0,1,1.112.88L1.266,7.207a.708.708,0,0,1-.557.269Z"
                  transform="translate(24.765 1.562)"
                  fill="#222433"
                />
                <g transform="translate(10.445 36.65)">
                  <ellipse
                    cx="5.629"
                    cy="5.622"
                    rx="5.629"
                    ry="5.622"
                    transform="translate(0.709 0.708)"
                    fill="#fff"
                  />
                  <path
                    d="M6.338,12.661a6.33,6.33,0,1,1,6.338-6.33,6.334,6.334,0,0,1-6.338,6.33Zm0-11.243A4.913,4.913,0,1,0,11.257,6.33,4.916,4.916,0,0,0,6.338,1.417Z"
                    transform="translate(0)"
                    fill="#222433"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(1426.402 161.5)">
          <g clip-path="url(#w)">
            <g transform="translate(0.397 0)">
              <g transform="translate(32.137 18.035)">
                <path
                  d="M2.023,8.062h7.6a1.707,1.707,0,0,0,0-3.414H7.175L9.826,3.216a1.749,1.749,0,0,0,.879-1.23A1.7,1.7,0,0,0,8.215.206L0,4.648"
                  transform="translate(0.615 0.617)"
                  fill="#fff"
                />
                <path
                  d="M10.241,9.3h-7.6a.616.616,0,0,1,0-1.233h7.6a1.091,1.091,0,1,0,0-2.182H7.79A.617.617,0,0,1,7.5,4.722L10.15,3.29a1.132,1.132,0,0,0,.565-.792,1.088,1.088,0,0,0-1.59-1.134L.907,5.807A.616.616,0,0,1,.323,4.722L8.538.28a2.318,2.318,0,0,1,3.388,2.427,2.364,2.364,0,0,1-1.184,1.664l-.514.278h.012a2.324,2.324,0,0,1,0,4.647Z"
                  fill="#222433"
                />
              </g>
              <path
                d="M.615,10.375a.616.616,0,0,1-.59-.789L2.684.444a.615.615,0,1,1,1.18.345L1.2,9.931a.615.615,0,0,1-.59.444Z"
                transform="translate(18.181 26.119)"
                fill="#222433"
              />
              <path
                d="M.615,10.375a.616.616,0,0,1-.59-.789L2.684.444a.615.615,0,1,1,1.18.345L1.205,9.931a.615.615,0,0,1-.59.444Z"
                transform="translate(14.55 26.119)"
                fill="#222433"
              />
              <path
                d="M7.336,0H0L6.824,3.575Z"
                transform="translate(0 5.299)"
                fill="#222433"
              />
              <g transform="translate(6.285 0)">
                <path
                  d="M9.37,26.071A6.984,6.984,0,0,1,2.4,19.085V14.77a8.807,8.807,0,0,0-1.383-4.6,6.673,6.673,0,0,1-1-4.1A6.547,6.547,0,0,1,1.952,1.937a6.659,6.659,0,0,1,4.2-1.92C6.314.006,6.475,0,6.634,0a6.642,6.642,0,0,1,6.347,4.753,14.486,14.486,0,0,0,2.441,4.911L28.058,26.07Z"
                  transform="translate(0.616 0.616)"
                  fill="#fff"
                />
                <path
                  d="M7.249,1.233a6.021,6.021,0,0,1,5.756,4.306,15.092,15.092,0,0,0,2.544,5.116L27.422,26.071H9.986A6.368,6.368,0,0,1,3.633,19.7V15.387a9.428,9.428,0,0,0-1.48-4.929,6.053,6.053,0,0,1-.9-3.723A5.928,5.928,0,0,1,3,2.994,6.045,6.045,0,0,1,6.814,1.248c.145-.01.291-.015.436-.015M7.249,0Q6.99,0,6.728.018a7.239,7.239,0,0,0-4.59,2.1A7.142,7.142,0,0,0,.027,6.634a7.242,7.242,0,0,0,1.086,4.479A8.156,8.156,0,0,1,2.4,15.387V19.7a7.6,7.6,0,0,0,7.582,7.6H29.925L16.523,9.9A13.868,13.868,0,0,1,14.187,5.2,7.23,7.23,0,0,0,7.249,0Z"
                  fill="#222433"
                />
              </g>
              <ellipse
                cx="1.844"
                cy="1.849"
                rx="1.844"
                ry="1.849"
                transform="translate(9.222 4.744)"
                fill="#222433"
              />
              <path
                d="M27.788,27.3H16.045A6.918,6.918,0,0,1,9.14,20.38l-.684-4.235a3.761,3.761,0,0,0-.443-.532L6.906,14.5a3.8,3.8,0,0,1-1.127-2.712A3.851,3.851,0,0,1,6.906,9.08,3.866,3.866,0,0,0,8.033,6.367V5.915A3.8,3.8,0,0,0,4.2,2.114H0A7.233,7.233,0,0,1,12.049,5.2,13.868,13.868,0,0,0,14.386,9.9Z"
                transform="translate(8.422 0.02)"
                fill="#3d3fea"
              />
              <path
                d="M8.381,10.91,0,0V4.869A6.043,6.043,0,0,0,6.025,10.91Z"
                transform="translate(22.177 15.111)"
                fill="#222433"
              />
            </g>
          </g>
        </g>
        <g transform="translate(1301.699 149.86)">
          <g clip-path="url(#x)">
            <g clip-path="url(#x)">
              <g transform="translate(0.01)">
                <path
                  d="M100.507,58.609,95.833,81.738H77.61L72.937,103.7h-28.8l4.543-21.964H1.727L7.425,56.1,65.191,1.74H94.284L82.6,58.609Zm-46.134,0L57,46.516q1.891-9.13,4.385-18.709a134.267,134.267,0,0,1-11.4,12.385L39.012,50.962a73.719,73.719,0,0,1-9.059,7.965c2.442-.185,5.251-.291,8.481-.291H54.373Z"
                  transform="translate(-0.949 -0.946)"
                  fill="#9fbfff"
                />
                <path
                  d="M72.009,103.55H43.2a.745.745,0,0,1-.6-.291.752.752,0,0,1-.158-.662l4.332-21.012H.8a.745.745,0,0,1-.6-.291.843.843,0,0,1-.158-.662l5.7-25.643a.628.628,0,0,1,.236-.4L63.712.212A.83.83,0,0,1,64.237,0H93.33a.745.745,0,0,1,.6.291.752.752,0,0,1,.158.662l-11.5,55.916H99.527a.745.745,0,0,1,.6.291.752.752,0,0,1,.158.662L95.667,80.977a.786.786,0,0,1-.761.635H77.339l-4.569,21.329A.79.79,0,0,1,72.009,103.55Zm-27.833-1.588h27.2l4.543-21.329A.786.786,0,0,1,76.683,80H94.249l4.359-21.541H81.646a.745.745,0,0,1-.6-.291.752.752,0,0,1-.158-.662l11.5-55.916H64.552L7.206,55.572,1.771,80.024h45.95a.745.745,0,0,1,.6.291.752.752,0,0,1,.158.662ZM29.026,58.748a.765.765,0,0,1-.735-.529.8.8,0,0,1,.289-.926,71.745,71.745,0,0,0,8.954-7.86l10.976-10.77A136.3,136.3,0,0,0,59.852,26.357a.8.8,0,0,1,.972-.212.756.756,0,0,1,.394.9c-1.654,6.351-3.125,12.623-4.385,18.683L54.207,57.822a.786.786,0,0,1-.761.635H37.507c-3.177,0-6.013.106-8.429.291Zm29.8-28.686c-2.836,3.308-5.934,6.589-9.243,9.765L38.636,50.571A88.28,88.28,0,0,1,31.6,57c1.812-.079,3.781-.132,5.908-.132H52.789l2.494-11.458C56.334,40.436,57.515,35.275,58.828,30.062Z"
                  transform="translate(-0.022)"
                  fill="#9fbfff"
                />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(1379.65 184.5)">
          <g clip-path="url(#z)">
            <g transform="translate(-0.254 -0.139)">
              <g transform="translate(9.585 17.878)">
                <path
                  d="M28.034,45.491a.643.643,0,0,0,.614-.83l-1.5-5.01a.641.641,0,1,0-1.228.371l1.5,5.01A.642.642,0,0,0,28.034,45.491Z"
                  transform="translate(-25.896 -39.192)"
                  fill="#222433"
                />
              </g>
              <g transform="translate(12.194 17.778)">
                <path
                  d="M22.513,44.713a.643.643,0,0,0,.614-.83L21.8,39.432a.641.641,0,1,0-1.228.371l1.329,4.45A.642.642,0,0,0,22.513,44.713Z"
                  transform="translate(-20.543 -38.973)"
                  fill="#222433"
                />
              </g>
              <g transform="translate(19.612 3.457)">
                <path
                  d="M0,7.58l4.565.644L.122,10.555Z"
                  transform="translate(0 -7.58)"
                  fill="#222433"
                />
              </g>
              <g transform="translate(0.011)">
                <path
                  d="M27.677,8.653a5.249,5.249,0,0,0-.834,2.779v2.818a4.928,4.928,0,0,1-4.916,4.94H8.967L17.675,7.856a9.257,9.257,0,0,0,1.517-3.065,4.7,4.7,0,1,1,8.494,3.853Z"
                  transform="translate(-8.326 -0.769)"
                  fill="#fff"
                />
                <path
                  d="M8.2,19.068h12.96a5.577,5.577,0,0,0,5.557-5.585V10.665a4.587,4.587,0,0,1,.708-2.393.639.639,0,0,0,.037-.053,5.351,5.351,0,1,0-9.652-4.379A8.59,8.59,0,0,1,16.4,6.7L7.7,18.03A.645.645,0,0,0,8.2,19.068ZM26.4,7.5c-.009.012-.018.024-.025.035a5.887,5.887,0,0,0-.936,3.122v2.825a4.29,4.29,0,0,1-4.275,4.3H9.509l7.91-10.3A9.866,9.866,0,0,0,19.046,4.2,4.063,4.063,0,1,1,26.4,7.5Z"
                  transform="translate(-7.563 -0.001)"
                  fill="#222433"
                />
              </g>
              <g transform="translate(15.782 3.736)">
                <ellipse
                  cx="1.203"
                  cy="1.209"
                  rx="1.203"
                  ry="1.209"
                  fill="#222433"
                />
              </g>
              <g transform="translate(0 0.002)">
                <path
                  d="M10.76,18.043l8.7-11.33a8.582,8.582,0,0,0,1.414-2.859,5.332,5.332,0,0,1,8.889-2.287.645.645,0,0,1-.452,1.1H26.586a1.848,1.848,0,0,0-1.839,1.847V4.81a1.84,1.84,0,0,0,.539,1.307,3.154,3.154,0,0,1,0,4.439l-.715.716a1.848,1.848,0,0,0-.539,1.31v1.342A5.148,5.148,0,0,1,18.9,19.081H11.267a.64.64,0,0,1-.575-.36A.647.647,0,0,1,10.76,18.043Z"
                  transform="translate(-10.626 -0.006)"
                  fill="#3d3fea"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

// export function ChevronRightIcon(props: SvgIconProps) {
//   return (
//     <SvgIcon viewBox="0 0 5 7" style={{ fill: "none" }} {...props}>
//       <path
//         d="M0.5 6.5L3.5 3.5L0.5 0.5"
//         stroke="#0CA6F2"
//         stroke-linecap="round"
//       />
//     </SvgIcon>
//   );
// }
